/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Section_NotesInputs */

const en_clients_section_notes = /** @type {(inputs: Clients_Section_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const pt_br2_clients_section_notes = /** @type {(inputs: Clients_Section_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observações`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Clients_Section_NotesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_section_notes = /** @type {((inputs?: Clients_Section_NotesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Section_NotesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_section_notes(inputs)
	return pt_br2_clients_section_notes(inputs)
});